/* global Swiper, gsap, ScrollTrigger */
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all.js';

import Swiper from 'swiper/bundle';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // Initialize hero Swiper
    const initHeroSlider = () => {
      const heroBanner = document.querySelector('.hero-section');
      if (heroBanner && typeof Swiper !== 'undefined') {
        new Swiper('.heroswiper', {
          speed: 1000,
          loop: true,
          pagination: {
            el: '.hero-swiper-pagination',
            clickable: true,
          },
          keyboard: {
            enabled: true,
          },
        });
      }
    };

    // Initialize review Swiper
    const initReviewSlider = () => {
      const reviewSlider = document.querySelector('.review-slider');
      if (reviewSlider && typeof Swiper !== 'undefined') {
        new Swiper('.reviewslider', {
          speed: 1000,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.review-swiper-pagination',
            clickable: true,
          },
          keyboard: {
            enabled: true,
          },
          breakpoints: {
            0: {
              loop: true,
              slidesPerView: 1,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 31,
              loop: false,
            },
          },
        });
      }
    };

    // Benefits-slider
    const initBenefitsSlider = () => {
      const benefitsSlider = document.querySelector('.benefits');
      if (benefitsSlider && typeof Swiper !== 'undefined') {
        new Swiper('.benefitswiper', {
          speed: 1000,
          pagination: {
            el: '.benefits-swiper-pagination',
            clickable: true,
          },
          keyboard: {
            enabled: true,
          },
          breakpoints: {
            0:{
              slidesPerView: 1,
              spaceBetween: 15,
              loop: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1366: {
              slidesPerView: 3,
              spaceBetween: 54,
              loop: false,
            },
          },
        });
      }
    };

    const initsolutionSlider = () => {
      const solutionSlider = document.querySelector('.solution-grid');
      if (solutionSlider) {
        new Swiper('.solution-slider', {
          speed: 1000,
          slidesPerView: 1,
          spaceBetween: 15,
          loop: true,
          navigation: {
            nextEl: '.solution-next',
            prevEl: '.solution-prev',
          },
          pagination: {
            el: '.solution-swiper-pagination',
            clickable: true,
          },
          keyboard: {
              enabled: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1366: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
            1600: {
              slidesPerView: 3,
              spaceBetween: 96,
            },
          },
        });
      }
    };

    // healthcare-solution-slider
    const inithsolutionSlider = () => {
      const heroBanner = document.querySelector('.healthcare-solution');
      if (heroBanner) {
        new Swiper('.healthcare-slider', {
          speed: 1000,
          spaceBetween: 40,
          loop: false,
          pagination: {
            el: '.healthcare-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.healthcare-next',
            prevEl: '.healthcare-prev',
          },
          keyboard: {
              enabled: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              grid: {
                rows: 1,
                fill: 'wrap',
              },
              spaceBetween: 20,
              slidesPerGroup: 1,
            },
            767: {
              slidesPerView: 2,
              grid: {
                rows: 1,
                fill: 'row',
              },
              slidesPerGroup: 2,
            },
            992: {
              slidesPerView: 2,
              grid: {
                rows: 2,
                fill: 'row',
              },
              slidesPerGroup: 2,
            },
            1200: {
              slidesPerView: 3,
              grid: {
                rows: 2,
                fill: 'row',
              },
              slidesPerGroup: 3,
              spaceBetween: 30,
            },
            1441: {
              slidesPerView: 3,
              grid: {
                rows: 2,
                fill: 'row',
              },
              slidesPerGroup: 3,
              spaceBetween: 40,
            },
          },

        });
      }
    };

    // treatment-slider
    const inittreatmentSlider = () => {
      const heroBanner = document.querySelector('.treatment');
      if (heroBanner) {
        new Swiper('.treatment-card-slider', {
          speed: 1000,
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          pagination: {
            el: '.solution-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.treatment-next',
            prevEl: '.treatment-prev',
          },
          keyboard: {
              enabled: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 2,
            },
            1250: {
              slidesPerView: 3,
            },
          },
        });
      }
    };

    // accordation
    $('.accordion .dt').on('click', function () {
      const current_dt = $(this);
      const current_dd = current_dt.next('.dd');

      const isInner = current_dt.hasClass('accordion-title-inner');
      const mainSelector = '.accordion-title-main';
      const innerSelector = '.accordion-title-inner';

      if (isInner) {
          // Toggle logic for nested (inner) titles
          if (!current_dd.hasClass('active')) {
              current_dt
                  .parent()
                  .find(innerSelector)
                  .not(current_dt)
                  .removeClass('open');
              current_dt.addClass('open');
          } else {
              current_dt.removeClass('open');
          }
      } else {
          // Toggle logic for main titles
          if (!current_dd.hasClass('active')) {
              // Remove .open from all other main titles
              $(mainSelector).not(current_dt).removeClass('open');

              // Remove .open from all inner titles inside other main sections
              $(mainSelector).not(current_dt).each(function () {
                  $(this)
                      .next('.dd')
                      .find(innerSelector)
                      .removeClass('open');
              });

              current_dt.addClass('open');
          } else {
              current_dt.removeClass('open');
          }
      }

      // Accordion slide logic (unchanged)
      if (!current_dd.hasClass('active')) {
          if (current_dt.siblings('.dd.active').length) {
              current_dt
                  .siblings('.dd.active')
                  .slideUp(function () {
                      current_dd.slideDown().addClass('active');
                  })
                  .removeClass('active')
                  .find('.dd.active')
                  .hide()
                  .removeClass('active');
          } else {
              current_dd.slideDown().addClass('active');
          }
      } else {
          current_dd.slideUp().removeClass('active');
      }

  });


  $(document).ready(function() {
    const mainSelector = '.accordion-title-main';
    const innerSelector = '.accordion-title-inner';


    // 1. Open first main accordion by default
    const firstMain = $(mainSelector).first();
    firstMain.addClass('open');
    const firstMainDD = firstMain.next('.dd');
    firstMainDD.addClass('active').show();

    // 2. Inside that first main accordion, open last nested accordion by default
    const nestedAccordions = firstMainDD.find(innerSelector);
    if (nestedAccordions.length) {
      const lastNested = nestedAccordions.last();
      lastNested.addClass('open');
      const lastNestedDD = lastNested.next('.dd');
      lastNestedDD.addClass('active').show();
    }
  });


    // Fade-up animation with GSAP
    const initFadeInUp = () => {
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        const fadeItems = gsap.utils.toArray('.anim_fadeinup');
        fadeItems.forEach((box) => {
          const anim = gsap.fromTo(
            box.children,
            { autoAlpha: 0, y: 50 },
            {
              delay: 0.2,
              duration: 1,
              autoAlpha: 1,
              y: 0,
              stagger: 0.25,
              ease: 'power2.out',
            }
          );

          ScrollTrigger.create({
            trigger: box,
            animation: anim,
            toggleActions: 'play none none none',
            once: false,
          });
        });
      }
    };
     // our-team-slider
     const initourteamSlider = () => {
      const heroBanner = document.querySelector('.our-team');
      if (heroBanner) {
        new Swiper('.ourteam-slider', {
          speed: 1000,
          pagination: {
            el: '.our-team-swiper-pagination',
            clickable: true,
          },
          keyboard: {
              enabled: true,
          },
          breakpoints: {
            0:{
              loop: true,
              slidesPerView: 1,
              spaceBetween: 15,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
            1520: {
              slidesPerView: 3,
              spaceBetween: 150,
              loop: false,
            },
          },
        });
      }
    };

        // popup-start
        //  'open_popup' is clicked
    document.querySelectorAll('.open_popup').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const card = this.closest('.choose-card');
        const targetId = card.getAttribute('id');
        const popup = document.querySelector(`.popup_body[data-target="${targetId}"]`);

        if (popup) {
          popup.classList.add('popup_body_show');
        }
      });
    });

    // Close popup when .popup_close or .popup_back is clicked
    document.querySelectorAll('.popup_close, .popup_back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.popup_body').forEach(function (popup) {
          popup.classList.remove('popup_body_show');


        });
      });
    });

    // popup-end

    // Counter animation with GSAP
    const initCounter = () => {
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.create({
          trigger: '.counters',
          start: 'top 98%',
          once: true,
          onEnter: () => {
            gsap.from('.counters-inner', {
              opacity: 0,
              y: 50,
              duration: 1,
              ease: 'power2.out',
            });

            // Counter animation logic
            document.querySelectorAll('.counter').forEach(counter => {
              counter.innerText = '0';
              const updateCounter = () => {
                const target = +counter.getAttribute('data-target');
                const count = +counter.innerText;
                const increment = target / 100;
                if (count < target) {
                  counter.innerText = `${Math.ceil(count + increment)}`;
                  setTimeout(updateCounter, 20);
                } else {
                  counter.innerText = target;
                }
              };
              updateCounter();
            });
          },
        });
      }
    };

    // Run all initializations
    initHeroSlider();
    initReviewSlider();
    initBenefitsSlider();
    initsolutionSlider();
    inithsolutionSlider();
    initourteamSlider();
    inittreatmentSlider();
    initFadeInUp();
    initCounter();
  },

};
